import React, { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Header } from './header';
import { Occupant } from './occupant';
import Loader from 'core/react/general/Loader';
import { zonesMapSelector } from 'core/redux/selectors/zones';
import { IZoneOccupancy } from 'types/redux/zoneGuardsOccupancy';
import { devicesMapSelector } from 'core/redux/selectors/devices';

import styles from './styles.module.css';

interface IOccupanciesByDeviceProps {
  isLoading: boolean;
  occupancies?: IZoneOccupancy[];
}

export const OccupanciesByDevice: FC<IOccupanciesByDeviceProps> = ({ isLoading, occupancies }) => {
  const devices = useSelector(devicesMapSelector);
  const zones = useSelector(zonesMapSelector);

  const occupants = useMemo(() => {
    const data: { uri: string; zoneId: number }[] = [];

    if (occupancies) {
      occupancies.forEach((occupancy) => {
        occupancy.occupancies.forEach(({ occupant }) => {
          data.push({ uri: occupant, zoneId: occupancy.zoneId });
        });
      });
    }

    return data;
  }, [occupancies]);

  return (
    <div className={styles.wrapper}>
      <Header />
      {isLoading ? (
        <div className={styles.noContent}>
          <Loader className="loader" size={Loader.Size.MD} />
        </div>
      ) : occupancies?.length ? (
        occupants.map(({ uri, zoneId }) => (
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          <Occupant key={uri} name={devices?.[uri].denomination() || '-'} zone={zones?.[zoneId]?.name || '-'} />
        ))
      ) : (
        <div className={styles.noContent}>No data</div>
      )}
    </div>
  );
};
